import { useState } from "react";
import { NavLink } from "react-router-dom";
import bars from "../../../assets/images/icons/bars.svg";
import close from "../../../assets/images/icons/close.svg";
import logo from "../../../assets/images/logo/logo.png";

const NavBar = () => {
  const [showParent, setShowParent] = useState(false);
  return (
    <section className="navbar slide-in-down">
      <div className="container">
        <div className="large">
          <div className="navbar-inner paint-texture">
            <div className="nav-contents flex">
              <div className="brand-part">
                <a href="/home">
                  <img
                    src={logo}
                    className="nav-logo"
                    alt="Flexi Painters Logo"
                  />
                </a>
              </div>
              <div className="nav-part">
                <nav className="nav relative boldTitle">
                  <label
                    onClick={() => setShowParent(true)}
                    htmlFor="toggle-responsive-menu"
                    className="nav-label bold-title"
                  >
                    <img src={bars} alt="Menu" />
                  </label>
                  <input type="checkbox" id="toggle-responsive-menu" />
                  <div
                    onClose={() => setShowParent(false)}
                    showParent={showParent}
                    className={`menu-inner ${showParent ? "showParent" : ""}`}
                  >
                    <div className="hide-menu">
                      <button
                        onClick={() => setShowParent(false)}
                        className="hide-menu-btn button"
                      >
                        <img src={close} alt="Close Menu" />
                      </button>
                    </div>
                    <ul className="menu" onClick={() => setShowParent(false)}>
                      <li>
                        <NavLink
                          to="/home"
                          className={({ isActive }) =>
                            isActive ? "active" : " "
                          }
                        >
                          Home
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/about"
                          className={({ isActive }) =>
                            isActive ? "active" : " "
                          }
                        >
                          About
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/services"
                          className={({ isActive }) =>
                            isActive ? "active" : " "
                          }
                        >
                          Services
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/portfolio"
                          className={({ isActive }) =>
                            isActive ? "active" : " "
                          }
                        >
                          Portfolio
                        </NavLink>
                      </li>
                      {/*
                      <li>
                        <NavLink
                          to="/case-studies"
                          className={({ isActive }) =>
                            isActive ? "active" : " "
                          }
                        >
                          Case Studies
                        </NavLink>
                      </li>
                      */}
                    </ul>
                  </div>
                </nav>
                <div className="cta-part flex">
                  <div className="cta-part-contact">
                    <div className="cta-part-contact-item cta-part-contact-link">
                      <a href="/contact">Contact Us &rarr;</a>
                    </div>
                    <div className="cta-part-contact-item cta-part-contact-phones boldTitle">
                      <span>Call: </span>
                      <a href="tel:+256775866449"> +256-775-866-449</a>
                    </div>
                  </div>
                  <div className="cta-part-quotation">
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      className="button nav-cta"
                    >
                      Book Site Visit
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NavBar;
